
import * as $ from 'jquery';

import * as CanvasTemplates from 'src/integration/canvas/templates';
import * as CanvasPreview from 'src/integration/canvas/ui/preview';
import * as CanvasUiUtil from 'src/integration/canvas/ui/util';
import * as AllyIntegrationUtil from 'src/integration/util';
import { FileReference } from 'src/shared/rest/domain/FileReference';

/****************
 * MODULES LIST *
 ****************/

var moduleFileReferences = [];

/**
 * Start polling the modules page for file modules to augment
 */
export function initList() {
    modulesListingPoller();
}

/**
 * Poll the modules
 */
function modulesListingPoller() {
    // Get the file ids for each file that's been linked as a module. We could retrieve these ids from the global
    // `window.ENV.MODULE_FILE_DETAILS` too, but modules that are added dynamically would be missed. Each file
    // attachment in the modules list has a class name of `Attachment_<file id>`. The `Attachment_<id>` class
    // seems to added after the `attachment` class. Ensure that the Attachment_id class is present before trying
    // to parse out the file id.
    var fileReferences = $('li.context_module_item.attachment')
        .map(function() { return $(this).attr('class'); })
        .toArray()
        .filter(function(classAttr) { return (classAttr.indexOf('Attachment_') > 0); })
        .map(function(classAttr) { return classAttr.split('Attachment_')[1].split(' ')[0].trim(); })
        .map(function(fileId) { return new FileReference(fileId); });

    var fileReferenceIds = fileReferences.map(function(ref) { return ref.id(); });
    var moduleFileReferenceIds = moduleFileReferences.map(function(ref) { return ref.id(); });

    if (fileReferenceIds.sort().toString() !== moduleFileReferenceIds.sort().toString()) {
        moduleFileReferences = fileReferences;
        CanvasUiUtil.getFileInformation(fileReferences, function(err, data) {
            if (!err) {
                $.each(data.files, augmentModuleInModulesListing);
            }
        });
    }

    CanvasPreview.pollPreview(
        function() {
            return true;
        },
        function($previewOverlay) {
            return CanvasUiUtil.getFileId($previewOverlay.find('.ef-file-preview-header-download').attr('href'));
        }
    );

    setTimeout(modulesListingPoller, 1000);
}

/**
 * Augment a module in the modules listing
 *
 * @param  {String}    fileReferenceId  The file reference id
 * @param  {Object}    file             The file information
 */
function augmentModuleInModulesListing(fileReferenceId, file) {
    var fileId = file.id;
    var $rowIconContainer = $(`li.context_module_item.attachment.Attachment_${ fileId } .ig-admin`);
    if (AllyIntegrationUtil.hasScore(file) && $rowIconContainer.length > 0) {
        var $scoreIndicator = $('.ally-accessibility-score-indicator', $rowIconContainer);
        var $newScoreIndicator = AllyIntegrationUtil.createScoreIndicator(file);
        if ($scoreIndicator.length === 0) {
            // Prepend the score indicator to the icons if it's not there already
            $rowIconContainer.prepend($newScoreIndicator);
        } else {
            // Replace the score indicator in the set of icons. This can happen after updating the description
            // for an image file as the score indicator needs to be updated
            $scoreIndicator.replaceWith($newScoreIndicator);
        }
    }
}

/************************************
 * SINGLE FILE MODULE DOWNLOAD PAGE *
 ************************************/

/**
 * Augment the download page for a file module
 */
export function initSingleFileDownload() {
    var $content = $('#content');
    $content.addClass('ally-module-file');
    var $link = $('a[href*="/download"]', $content);
    var fileId = CanvasUiUtil.getFileId($link.attr('href'));
    var fileReference = new FileReference(fileId);
    var fileReferenceId = fileReference.id();
    CanvasUiUtil.getFileInformation([fileReference], function(err, data) {
        if (!err) {
            updateFileModuleDownloadPage(fileReferenceId, data.files[fileReferenceId]);
        }
    });
}

/**
 * Inject or update the score indicator and AAF dropdown in the file module download page
 *
 * @param  {String}    fileId    The id of the file
 * @param  {Object}    file      The file information
 */
function updateFileModuleDownloadPage(fileReferenceId, file) {
    var $content = $('#content');
    var $h2 = $('h2:first', $content);

    // Only show the instructor feedback if the user can manage the course. Unfortunately, there's not a lot of data
    // to key that permission check of in this view. If the user sees the settings link in the left hand navigation,
    // it's assumed they can update files
    if (AllyIntegrationUtil.hasScore(file) && CanvasUiUtil.canManageCourse()) {
        var $scoreIndicator = $('.ally-accessibility-score-indicator', $h2);
        var $newScoreIndicator = AllyIntegrationUtil.createScoreIndicator(file);
        if ($scoreIndicator.length === 0) {
            $h2.append($newScoreIndicator);
        } else {
            $scoreIndicator.replaceWith($newScoreIndicator);
        }
    }

    // Accessible versions can always be shown if available
    var $allyDropdown = $('div:first .ally-enhancement', $content);
    var fileInfo = CanvasUiUtil.fileInformation()[fileReferenceId];
    if (fileInfo && AllyIntegrationUtil.hasAvailableAlternativeFormats(file) && $allyDropdown.length === 0) {
        $('div:first', $content).append(CanvasTemplates.apply('ally-user-content-prominent-icon', {
            'fileId': fileInfo.id
        }));
    }
}

/****************
 * FILE UPDATES *
 ****************/

/**
 * Invoked when a file has been replaced
 *
 * @param  {Object}    file            The updated file
 * @param  {Object}    originalFile    The original file
 */
export function fileReplaced(file, originalFile, callback) {
    // Get all the module items where this file is linked. If the module title is the same as the file name,
    // update the title of the module to the new file name
    var courseId = CanvasUiUtil.getCourseId();
    $.ajax({
        'type': 'GET',
        'url': `/api/v1/courses/${ courseId }/module_item_sequence?asset_type=File&asset_id=${ file.id}`,
        'success': function(data) {
            var moduleItems = data.items
                .map(function(item) {
                    return {
                        'moduleId': item.current.module_id,
                        'moduleItemId': item.current.id,
                        'moduleItemTitle': item.current.title
                    };
                })
                .filter(function(data) {
                    // Filter out module items where the instructor has changed the title from the default
                    // file name
                    return (data.moduleItemTitle === originalFile.name.trim());
                });
            updateModuleItemsTitle(moduleItems, file, callback);
        },
        'error': callback
    });
}

/**
 * Update the title for a set of module items
 *
 * @param  {Object[]}    moduleItems    The module items to update. Each object should have a `moduleId`,
 *                                      `moduleItemId` and `moduleTitle` key
 * @param  {Object}      newFile        The new file information
 * @param  {Function}    callback       Invoked when all module items have been updated
 */
function updateModuleItemsTitle(moduleItems, newFile, callback) {
    var courseId = CanvasUiUtil.getCourseId();

    // Update the module items synchronously
    var i = -1;
    function next() {
        i++;
        if (i < moduleItems.length) {
            var moduleId = moduleItems[i].moduleId;
            var moduleItemId = moduleItems[i].moduleItemId;
            $.ajax({
                'type': 'PUT',
                'url': `/api/v1/courses/${ courseId }/modules/${ moduleId }/items/${ moduleItemId}`,
                'data': {
                    'module_item[title]': newFile.name
                },

                // This is a best effort, regardless of whether the request was succesful, always continue so
                // that the page eventually gets reloaded
                'complete': next
            });
        } else {
            return callback();
        }
    }
    next();
}
